import type { MonetarySet } from '../types/general-data'
import { ApiModel } from '@composable-api/api.model'
import type { GetPriceOptions } from '@simploshop-models/product.model'
import { getFormattedPrice } from '../utils/localization'

interface Attributes {
    [CartDiscountModel.ATTR_ID]: number
    [CartDiscountModel.ATTR_NAME]: string | null
    [CartDiscountModel.ATTR_CODE]: string | null
    [CartDiscountModel.ATTR_AMOUNTS]: MonetarySet
}

export class CartDiscountModel extends ApiModel<Attributes> {
    static key = 'CartDiscountModel'

    static readonly ATTR_ID = 'id'
    static readonly ATTR_NAME = 'name'
    static readonly ATTR_CODE = 'code'
    static readonly ATTR_AMOUNTS = 'amounts'

    get id() {
        return this._getAttribute(CartDiscountModel.ATTR_ID)
    }

    get name() {
        return this._getAttribute(CartDiscountModel.ATTR_NAME)
    }

    get code() {
        return this._getAttribute(CartDiscountModel.ATTR_CODE)
    }

    private get amounts() {
        return this._getAttribute(CartDiscountModel.ATTR_AMOUNTS)
    }

    getPrice(options?: Partial<GetPriceOptions>) {
        return (options?.tax !== false ? this.amounts?.pair?.taxed_price : this.amounts?.pair?.price) ?? null
    }

    getFormattedPrice(options?: Partial<GetPriceOptions>) {
        return getFormattedPrice(this.getPrice(options))
    }
}
